import { render, staticRenderFns } from "./WizardPageProducts.vue?vue&type=template&id=329a8548&scoped=true&"
import script from "./WizardPageProducts.vue?vue&type=script&lang=js&"
export * from "./WizardPageProducts.vue?vue&type=script&lang=js&"
import style0 from "./wizard-page-products.scss?vue&type=style&index=0&id=329a8548&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329a8548",
  null
  
)

export default component.exports